export const access_token = process.env.REACT_APP_ACCESS_TOKEN;
export const refresh_token = process.env.REACT_APP_REFRESH_TOKEN;
export const api_urls_http = process.env.REACT_APP_APP_URLS_HTTP;
export const api_urls_https = process.env.REACT_APP_APP_URLS_HTTPS;
export const project_name = process.env.REACT_APP_PROJECT_NAME;